$(document).ready(function() {
function addDataCountToVariantBoxes() {
  $('li.blank_variant_box').each(function(i, obj) {
    $(this).attr('data-count', i + 1);
  });
}
  
addDataCountToVariantBoxes();
  
    function checkButtonStatus() {
      var boxes_size = $('.blank_variant_box').length;
      var selected_boxes_size = $('.itemadded').length;
      var qt = boxes_size - selected_boxes_size;
      var bundleBox = document.querySelector('.bundlebuybox');
      var subWidget = document.querySelector('.cstbutton_wrapper');
      var pb = document.querySelector('.mainpreviewblock');

       if (selected_boxes_size >= 1) { 
         bundleBox.classList.add('fixedbottom');
      } else {
        bundleBox.classList.remove('fixedbottom'); 
        }
      

        var totalPrice = 0;
        $('.blank_variant_box.itemadded').each(function() {
          var p = $(this).data('price');
          p = parseFloat(p);
          totalPrice = totalPrice + p;
        });
        totalPrice = totalPrice / 100;
      
        var resultDiscounted = (15 / 100) * parseFloat(totalPrice);
        var resultDiscountedAmt = parseFloat(totalPrice) - resultDiscounted;
        $('input#one-time-purchase').parent().find('label').html('One-Time Purchase  <span class="one-time-price">$' + totalPrice.toFixed(2) + '</span>');
        $('input#subscription_two').parent().find('label').html('Subscribe & Save 15% <span class="total-sub-price">$' + resultDiscountedAmt.toFixed(2) + '</span>&nbsp;<s class="sub-price">$' + parseFloat(totalPrice).toFixed(2) + '</s><br><span class="subinfor">FREE SHIPPING! Cancel, pause or swap your subscription any time.</span>');
        $('.custom-bundle-submit span').text('Add to cart');

        // add to cart button price
        var selectedPlan = $('[name="check_subscription"]:checked');
        var price = ''
        if (selectedPlan.attr('id') == 'one-time-purchase') {
          var price = selectedPlan.parent().find('label span.one-time-price').text();
        }  else if (selectedPlan.attr('id') == 'subscription_two') {
          var price = selectedPlan.parent().find('label span.total-sub-price').text();
        }
        if(price != '') {
          $('.custom-bundle-submit span').text(`Add to cart - ${price}`);
        } else {
          $('.custom-bundle-submit span').text(`Add to cart`);
        }
      
      //if (boxes_size == selected_boxes_size) {
      if (selected_boxes_size > 1) {
        pb.classList.remove('mrg-top'); 
        subWidget.classList.remove('disp-none');
        $('button.custom-bundle-submit').removeAttr('disabled');
      } else {
        pb.classList.add('mrg-top');
        subWidget.classList.add('disp-none');
        if (qt == 1) {
          $('.custom-bundle-submit span').text('Select '+qt+' more product');
        } else {
          $('.custom-bundle-submit span').text('Select '+qt+' more products');
        }
        $('.custom-bundle-submit span').text('Select 2 or more products');
        $('button.custom-bundle-submit').attr('disabled', 'disabled');

        if (qt == boxes_size) {
          $('input#one-time-purchase').parent().find('label').html('One-Time Purchase');
          $('input#subscription_two').parent().find('label').html('Subscribe & Save 15%');
        }
      }
    }

  
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    var form = document.querySelector(selectors.form);
    var drawer = new theme.Drawers('CartDrawer', 'cart');


    function init() {      
      var form = document.querySelector(selectors.form);
      var drawer = new theme.Drawers('CartDrawer', 'cart');
      var cartForm = new theme.CartForm(form);
      cartForm.buildCart();

      document.addEventListener('ajaxProduct:added', function(evt) {
        document.body.classList.add('cart-has-items');
        cartForm.buildCart();
        open();
      }.bind(this));

 
      document.addEventListener('cart:open', this.open.bind(this));
      document.addEventListener('cart:close', this.close.bind(this));
    };

    function open() {
      drawer.open();
    };

    function close() {
      drawer.close();
    }
  
    $('button.add_variant_box').click(function() {
      var img = $(this).parents('.variant_box').find('img').attr('src');
      var id = $(this).data('id');
      var price = $(this).data('price');
      var appendeditem = false;
      var html = '<img src="'+img+'" class="data-selected-id" data-selected-id="'+id+'" />'
      $('.blank_variant_box').each(function() {
        if (!appendeditem) {
          if (!$(this).hasClass('itemadded')) {
            $(this).append(html);
            $(this).addClass('itemadded');
            $(this).attr('data-price', price);
            appendeditem = true;
          }
        }
      });
      checkButtonStatus();
    });

    $(document).on('click', 'span.emptybox', function() {
      $(this).parents('.blank_variant_box').find('.data-selected-id').remove();
      $(this).parents('.blank_variant_box').removeClass('itemadded');
      $(this).parents('.blank_variant_box').removeAttr('data-price');

      var arrangedBoxes = '';
      var bottomBoxes = '';
      $('.blank_variant_box').each(function() {
        if ($(this).hasClass('itemadded')) {
          var price = $(this).attr('data-price');
          arrangedBoxes += '<li class="blank_variant_box itemadded" data-price="'+price+'">'+$(this).html()+'</li>';
        } else {
          bottomBoxes += '<li class="blank_variant_box">'+$(this).html()+'</li>';
        }
      });
      $('.blank_variant_box_wrapper').html(arrangedBoxes+bottomBoxes);
      checkButtonStatus();
      addDataCountToVariantBoxes();
    });

  
  $(document).on('click', '.cstbutton', function() {
    var radioValue = $("input[name='check_subscription']:checked").val();
    if (radioValue) {
      $('.dropdown.custom_product_variant_select').css('display', 'block');
      $('.one-time-radio').removeClass('checked');
      $('.sub-radio').addClass('checked');
    } else {
      $('.dropdown.custom_product_variant_select').css('display', 'none');
      $('.one-time-radio').addClass('checked');
      $('.sub-radio').removeClass('checked');
    }

    var selectedPlan = $('[name="check_subscription"]:checked');
    var price = ''
    if (selectedPlan.attr('id') == 'one-time-purchase') {
      var price = selectedPlan.parent().find('label span.one-time-price').text();
    }  else if (selectedPlan.attr('id') == 'subscription_two') {
      var price = selectedPlan.parent().find('label span.total-sub-price').text();
    }
    if(price != '') {
      $('.custom-bundle-submit span').text(`Add to cart - ${price}`);
    } else {
      $('.custom-bundle-submit span').text(`Add to cart`);
    }
  });
  
  $('button.custom-bundle-submit').on('click', function(){
    var productItems = [];    
    var productItemsFinal = [];
    var html = '';
    $(this).addClass('btn--loading');
    $('.itemadded .data-selected-id').each(function(i, v) {
      var id = $(this).attr('data-selected-id');
      productItems.push(id);
    });

    productItems.sort();

    var current = null;
    var cnt = 0;
    
    var radioValueStatus = $("input[name='check_subscription']:checked").val();
    
    var radioValue = '';
    if (radioValueStatus) {
      radioValue = $('select.product_variant_select.custom_product_variant_select').val();
    }
    for (var i = 0; i < productItems.length; i++) {
        if (productItems[i] != current) {
            if (cnt > 0) {
                var item = {
                  id: current,
                  quantity: cnt,
                  selling_plan: radioValue
                }
                productItemsFinal.push(item);
            }
            current = productItems[i];
            cnt = 1;
        } else {
            cnt++;
        }
    }
    if (cnt > 0) {
        var item = {
          id: current,
          quantity: cnt,
          selling_plan: radioValue
        }
        productItemsFinal.push(item);
    }

    var data = {
      items: productItemsFinal
    }; 
    
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: () => {
        $('button.custom-bundle-submit').removeClass('btn--loading');
        init();
        $('.js-drawer-open-cart').trigger('click');
        
        $('.blank_variant_box').removeClass('itemadded');
        $('.blank_variant_box img').remove();

        var boxes_size = $('.blank_variant_box').length;
        $('button.custom-bundle-submit span').text('Added');
        
        setTimeout(function() {
          $('button.custom-bundle-submit').attr('disabled', 'disabled');
          $('button.custom-bundle-submit span').text('Select '+boxes_size+' products');
        }, 1000);
        drawer.open();
      },
      error: function(xhr, status, error) {
        console.log(xhr);
        $('button.custom-bundle-submit').removeClass('btn--loading');
      },
      dataType: 'json'
    });
  });
});


function create_custom_dropdowns() {
  $('select.product_variant_select').each(function(i, select) {
    if (!$(this).next().hasClass('dropdown')) {
      $(this).after('<div class="dropdown ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
      var dropdown = $(this).next();
      var options = $(select).find('option');
      var selected = $(this).find('option:selected');
      dropdown.find('.current').html(selected.data('display-text') || selected.text());
      options.each(function(j, o) {
        var display = $(o).data('display-text') || '';
        var classs = $(o).attr('class') || '';
        dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') +' '+ classs + ' " data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
      });
    }
  });
}


$(document).on('click', '.dropdown', function(event) {
  $('.dropdown').not($(this)).removeClass('open');
  $(this).toggleClass('open');
  if ($(this).hasClass('open')) {
    $(this).find('.option').attr('tabindex', 0);
    $(this).find('.selected').focus();
  } else {
    $(this).find('.option').removeAttr('tabindex');
    $(this).focus();
  }
});

$(document).on('click', function(event) {
  if ($(event.target).closest('.dropdown').length === 0) {
    $('.dropdown').removeClass('open');
    $('.dropdown .option').removeAttr('tabindex');
  }
  event.stopPropagation();
});

function triggerMouseFunction(eventType) {
  const event = new MouseEvent(eventType, {
    bubbles: true,
    cancelable: true
  });
  this.dispatchEvent(event);
}
if (!EventTarget.prototype.triggerMouse) {
  EventTarget.prototype.triggerMouse = triggerMouseFunction;
}

var that = this.currentVariant;

$(document).on('click', 'button.initial_button.button', function(event) {
    $('.dropdown.custom_product_variant_select').attr('style', 'border-color: red;');
    setTimeout(function() {
      $('.dropdown.custom_product_variant_select').removeAttr('style');      
    }, 1500);
});

$(document).on('click', '.dropdown .option', function(event) {
  if ($(this).hasClass('disabledvariant')) {} else {
    $('button.initial_button.button').hide();
    $('.product-form__submit').removeAttr('style');
    $('form.form').removeClass('init');
    $('.btn.klaviyo-bis-trigger').show();
    
    $(this).closest('.list').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var text = $(this).data('display-text') || $(this).text();
    $(this).closest('.dropdown').find('.current').text(text);
    
    $(this).closest('.dropdown').prev('select').find('option').removeAttr('selected');
    var tvalue = $(this).data('value');
    console.log('tvaluetvalue', tvalue)
    var type = typeof tvalue;
    if (tvalue && type != 'number') {
      tvalue = tvalue.trim();
    }
  
    var idd = $(this).closest('.dropdown').prev('select').attr('id');
    $(this).closest('.dropdown').prev('select').find("option[value='"+tvalue+"']").attr('selected', 'selected');
    $(this).closest('.dropdown').prev('select').val(tvalue).trigger('change');
    $(this).closest('.dropdown').prev('select').val(tvalue).change();
  
    
    const e = new Event("change");
    const element = document.querySelector('.custom_product_variant_select');
    element.dispatchEvent(e);
    element.triggerMouse('click'); 
    setTimeout(function() {
      $('.dropdown').removeClass('open');
      $('.dropdown .option').removeAttr('tabindex');    
    },100)
  }
});


$(document).ready(function() {
  create_custom_dropdowns();
});


